import {
  CdkCell,
  CdkCellDef,
  CdkColumnDef,
  CdkFooterCell,
  CdkFooterCellDef,
  CdkFooterRow,
  CdkFooterRowDef,
  CdkHeaderCell,
  CdkHeaderCellDef,
  CdkHeaderRow,
  CdkHeaderRowDef,
  CdkRow,
  CdkRowDef,
} from '@angular/cdk/table';

export const ElCdkRowDef = CdkRowDef;
export const ElCdkRow = CdkRow;
export const ElCdkCellDef = CdkCellDef;

export const ElCdkHeaderRowDef = CdkHeaderRowDef;
export const ElCdkHeaderRow = CdkHeaderRow;
export const ElCdkHeaderCellDef = CdkHeaderCellDef;

export const ElCdkFooterRowDef = CdkFooterRowDef;
export const ElCdkFooterRow = CdkFooterRow;
export const ElCdkFooterCellDef = CdkFooterCellDef;

export const ElCdkColumnDef = CdkColumnDef;

export const ElCdkCell = CdkCell;
export const ElCdkHeaderCell = CdkHeaderCell;
export const ElCdkFooterCell = CdkFooterCell;
